import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ConsultType, TemplateFrequency } from '../../types/api/graphql';

export const useAgendaTemplateFrequencyValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      [
        TemplateFrequency.Once,
        TemplateFrequency.Daily,
        TemplateFrequency.Weekly,
        TemplateFrequency.TwoWeeks,
        TemplateFrequency.Monthly,
      ].map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.agenda-template-frequency.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};

export enum AgendaAppointmentType {
  DEFAULT = 'DEFAULT',
  SIMPLE = 'SIMPLE',
}

export const useAgendaAppointmentTypeValues = (
  type: AgendaAppointmentType = AgendaAppointmentType.DEFAULT
) => {
  const intl = useIntl();

  const data = useMemo(() => {
    let consulTypes = [
      ...Object.values(ConsultType).filter(
        option => ![ConsultType.Else, ConsultType.Exception].includes(option)
      ),
      ...[ConsultType.Else],
    ];

    if (type === AgendaAppointmentType.SIMPLE) {
      consulTypes = [ConsultType.Physical, ConsultType.Video];
    }

    return consulTypes.map(option => ({
      key: option,
      title: intl.formatMessage({
        id: `common.agenda-appointment-type.${kebabCase(option)}`,
      }),
    }));
  }, [intl, type]);

  return {
    data,
    loading: false,
  };
};
